import { render, staticRenderFns } from "./approval_has_approval.vue?vue&type=template&id=450ebb4b"
import script from "./approval_has_approval.vue?vue&type=script&lang=js"
export * from "./approval_has_approval.vue?vue&type=script&lang=js"
import style0 from "./approval_has_approval.vue?vue&type=style&index=0&id=450ebb4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports